import React from "react";
import { Card, Form, Select, Upload, Button, Tooltip } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "Common/global.scss";
import useDocumentsStore from "Hooks/AdminHooks/useDocumentStore";
import items from "./items";

const { Option } = Select;

export default function EmployeeForm() {
  const {
    selectedEmployeeNumber,
    selectedJobPostingId,
    form,
    jobPostings,
    feedbackEmployees,
    loading,
    isSubmitDisabled,
    handleFormSubmit,
    handleFileChange,
    handleJobPostingChange,
    handleFeedbackEmployeeChange,
    employeeDetails,
    handleDocumentClick, //  reuse for downloading templates
  } = useDocumentsStore();

  return (
    <Card
      title="Employee Documents"
      className="card-professional"
      bordered={false}
      style={{ marginTop: 20 }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ employeeNumber: "" }}
        onFinish={handleFormSubmit}
      >
        <div className="row">
          <div className="col-md-6">
            <Form.Item
              label="Job Postings"
              name="jobPostingId"
              rules={[{ required: true, message: "Please select a job posting!" }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select a Job Title"
                onChange={handleJobPostingChange}
                value={selectedJobPostingId || undefined}
              >
                {jobPostings
                  .filter((employee) => employee.id != null)
                  .map((employee) => (
                    <Option key={employee.id} value={String(employee.id)}>
                      {employee.jobTitle}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
          <div className="col-md-5">
            <Form.Item
              label="Feedback Added Employees"
              name="jobApplicantId"
              rules={[{ required: true, message: "Please select the Employee" }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select an Employee"
                onChange={handleFeedbackEmployeeChange}
                value={selectedEmployeeNumber}
              >
                {feedbackEmployees
                  .filter((emp) => emp.jobApplicantId != null)
                  .map((emp) => (
                    <Option key={emp.jobApplicantId} value={String(emp.jobApplicantId)}>
                      {`${emp?.firstName} ${emp?.lastName}`}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <b>Name:</b>&nbsp;
            <span className="text-muted">
              {employeeDetails?.firstName} {employeeDetails?.lastName}
            </span>
          </div>
          <div className="col-md-6">
            <b>Email:</b>&nbsp;
            <span className="text-muted">{employeeDetails?.email}</span>
          </div>
        </div>

        {/* Upload Sections with Download Links */}
        <div className="row">
          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  NDA File (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "ndafile"))}>Download Template</a>)
                </span>
              }
              name="ndafile"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload the NDA file!" }]}
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange("ndafile")}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload NDA</Button>
              </Upload>
            </Form.Item>
          </div>

          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  NCA File (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "ncafile"))}>Download Template</a>)
                </span>
              }
              name="ncafile"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload the NCA file!" }]}
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange("ncafile")}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload NCA</Button>
              </Upload>
            </Form.Item>
          </div>

          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  I-9 File (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "i_nine"))}>Download Template</a>)
                </span>
              }
              name="i_nine"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload the I-9 file!" }]}
            >
              <Upload beforeUpload={() => false} onChange={handleFileChange("i_nine")} maxCount={1}>
                <Button icon={<UploadOutlined />}>Upload I-9</Button>
              </Upload>
            </Form.Item>
          </div>
        </div>

        <div className="row">
          <div className="col-md-4">
            <Form.Item
             label={
              <span>
                W-4 File (
                <a onClick={() => handleDocumentClick(items.find(i => i.key === "w_four"))}>Download Template</a>)
              </span>
            }
              name="w_four"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload the W-4 file!" }]}
            >
              <Upload beforeUpload={() => false} onChange={handleFileChange("w_four")} maxCount={1}>
                <Button icon={<UploadOutlined />}>Upload W-4</Button>
              </Upload>
            </Form.Item>
          </div>
          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  Employee Agreement (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "employeeAgreement"))}>Download Template</a>)
                </span>
              }
              name="employeeAgreement"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload Employee Agreement!" }]}
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange("employeeAgreement")}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload Agreement</Button>
              </Upload>
            </Form.Item>
          </div>

          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  Offer Letter (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "offerLetter"))}>Download Template</a>)
                </span>
              }
              name="offerLetter"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload the Offer Letter!" }]}
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange("offerLetter")}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload Offer Letter</Button>
              </Upload>
            </Form.Item>
          </div>

          <div className="col-md-4">
            <Form.Item
              label={
                <span>
                  HR Policy (
                  <a onClick={() => handleDocumentClick(items.find(i => i.key === "hrPolicy"))}>Download Template</a>)
                </span>
              }
              name="hrpolicy"
              valuePropName="fileList"
              getValueFromEvent={(e) => (Array.isArray(e) ? e : e?.fileList)}
              rules={[{ required: true, message: "Please upload HR Policy!" }]}
            >
              <Upload
                beforeUpload={() => false}
                onChange={handleFileChange("hrpolicy")}
                maxCount={1}
              >
                <Button icon={<UploadOutlined />}>Upload HR Policy</Button>
              </Upload>
            </Form.Item>
          </div>
        </div>

        <Form.Item>
          <Tooltip title={isSubmitDisabled ? "Select an employee first" : ""}>
            <span>
              <Button
                type="primary"
                className="card-professional"
                htmlType="submit"
                disabled={isSubmitDisabled || loading}
                loading={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </span>
          </Tooltip>
        </Form.Item>
      </Form>
    </Card>
  );
}
